module.exports = __webpack_public_path__ + "img/pic2.d1c07302.png";